import React from "react";
import { Link2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { shareUrl } from "@/lib/share";
import { excerpt, fill } from "@/lib/prayers";

// « Partager le lien » : feuille de partage du téléphone (WhatsApp, Messenger…) avec le lien /api/e/prayer/<id>
// → aperçu dédié (badge, auteur ou « Un membre », extrait). Web sans partage natif : lien copié.
export const PrayerLinkShare = ({ p, variant = "outline" }) => {
  const { t } = useApp();
  const share = (e) => {
    e.stopPropagation();
    const text = excerpt(p.content || "", 120);
    const name = (p.author?.name || "").split(" ")[0];
    const msg = p.is_mine || !name
      ? fill(t("prayers.share_text_mine", "🙏 Prie avec moi sur Yalola : {text}"), { text })
      : fill(t("prayers.share_text_other", "🙏 Prions pour {name} sur Yalola : {text}"), { name, text });
    shareUrl({ title: "Yalola", text: msg, url: `/prayers?focus=${p.id}`, copiedMsg: t("prayers.share_copied", "Lien de la prière copié 🔗") });
  };
  return (
    <Button size="sm" variant={variant} className="rounded-full" onClick={share} data-testid={`prayer-share-link-${p.id}`}>
      <Link2 size={14} className="mr-1" /> {t("prayers.share_link", "Partager le lien")}
    </Button>
  );
};
